import { Lock, ArrowUpLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { FEATURE_LABELS, PLANS, FEATURE_MIN_PLAN, userHasFeature } from "@/lib/plans";

// شاشة القفل: تبويب مُقيَّد بالباقة — يظهر مظللاً برسالة ترقية بدل إخفائه
export default function PlanGate({ feature, onUpgrade, children }) {
  const { user } = useAuth();
  if (userHasFeature(user, feature)) return children;

  const minPlan = FEATURE_MIN_PLAN[feature];
  const required = minPlan ? PLANS[minPlan]?.name : "باقة أعلى";
  const featureName = FEATURE_LABELS[feature] || "هذه الميزة";

  return (
    <div className="bg-white rounded-2xl border shadow-sm p-10 text-center space-y-5"
      data-testid={`plan-gate-${feature}`}>
      <div className="w-16 h-16 rounded-2xl bg-amber-100 flex items-center justify-center mx-auto">
        <Lock className="w-8 h-8 text-amber-700" />
      </div>
      <div>
        <h2 className="text-lg font-extrabold text-emerald-950" data-testid={`plan-gate-title-${feature}`}>
          {featureName} — متاحة في الباقة {required}
        </h2>
        <p className="text-sm text-slate-500 leading-7 mt-2 max-w-md mx-auto">
          باقتك الحالية لا تشمل {featureName}. رقِّ اشتراكك إلى الباقة {required} أو أعلى
          لتفعيلها فوراً مع الاحتفاظ بكل بياناتك.
        </p>
      </div>
      <button onClick={onUpgrade} data-testid={`plan-gate-upgrade-${feature}`}
        className="inline-flex items-center gap-2 bg-emerald-900 hover:bg-emerald-950 text-white rounded-xl px-6 py-3 text-sm font-bold transition-colors">
        <ArrowUpLeft className="w-4 h-4" /> ترقية الاشتراك
      </button>
    </div>
  );
}
